/* eslint-disable react/no-array-index-key, react/no-danger */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Cards from "@hasanboy93/react-cards-uz";
import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import axios from "axiosClient";
import axiosPayment from "axiosClientPayment";
import moment from "moment";

import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "@hasanboy93/react-cards-uz/dist/es/styles-compiled.css";
import { Tooltip } from "react-tooltip";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

import {
  formatCreditCardNumber,
  formatExpirationDate,
  formatOtp,
  formatPhone,
} from "utils/formatCardValues";

import { currencyFormatter } from "utils/formatter";

const momentTz = require("moment-timezone");

const Payment = ({ user, token }) => {
  const [price, setPrice] = useState(0);
  const [transactionId, setTransactionId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enquiryDetails, setEnquiryDetails] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [isPost, setIsPost] = useState(false);
  const [forPayment, setForPayment] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [residence, setResidence] = useState("Uzbekistan");
  const [validate, setValidate] = useState({
    emailState: "",
    passportState: "",
  });
  const [dob, setDob] = useState(null);
  const [examDate, setExamDate] = useState(null);
  const [cardPhone, setCardPhone] = useState("");
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [testId, setTestId] = useState(null);
  const [hasUserDetails, setHasUserDetails] = useState(false);

  const { t, i18n } = useTranslation();

  const naviagate = useNavigate();

  const [cardDetails, setCardDetails] = useState({
    number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
    phone: "",
    otp: "",
  });

  const handleInputChange = (evt) => {
    let { name, value } = evt.target;
    let newValue;
    if (name === "number") {
      value = formatCreditCardNumber(value);
    } else if (name === "expiry") {
      value = formatExpirationDate(value);
    } else if (name === "phone") {
      value = formatPhone(value);
    } else if (name === "otp") {
      value = formatOtp(value);
    }
    setCardDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputFocus = (evt) => {
    setCardDetails((prev) => ({ ...prev, focus: evt.target.name }));
  };
  const handleResidenceChange = (e) => {
    setResidence(e.value);
  };

  const handleModuleChange = (e) => {
    setSelectedModule(e.value);
  };

  const handleValuesChange = (e) => {
    if (residence === "Uzbekistan" && e.target.name === "passportId") {
      setEnquiryDetails({
        ...enquiryDetails,
        [e.target.name]: e.target.value.toUpperCase().replace(" ", ""),
      });
    } else {
      let value = e.target.value;

      setEnquiryDetails({ ...enquiryDetails, [e.target.name]: value });
    }
    setErrorMessage("");
  };

  const validatePassportId = (e) => {
    let rex = /[A-Z]{2}[0-9]{7}/;
    if (rex.test(e.target.value)) {
      setValidate({ ...validate, passportState: "has-success" });
    } else {
      setValidate({ ...validate, passportState: "has-danger" });
    }
  };

  const handlePrePayment = (e) => {
    e.preventDefault();
    setPaymentLoading(true);
    // console.log(cardDetails);
    let cardNumber = cardDetails.number.replace(/\s/g, "");
    if (cardNumber.length !== 16) {
      return toast.error(`Please enter correct 16-digit card number`);
    }
    let year = cardDetails.expiry.split("/")[1];
    let month = cardDetails.expiry.split("/")[0];
    const timeInGMT5 = momentTz.tz("Asia/Karachi").format("DD/MM/YYYY");
    axiosPayment
      .post(`/api/via/pre`, {
        cardNumber: cardNumber,
        cardExpire: `${month}${year}`,
        enquiryId: `VIA ${timeInGMT5} ID:${enquiryDetails.pinpp}:${
          enquiryDetails?.passportId
        }:${enquiryDetails.firstName} ${
          enquiryDetails.lastName
        }:${moment().format("DD.MM.YYYY")}:${enquiryDetails.region}:${
          enquiryDetails.exam
        }`,
        amount: price.exam * 100,
        // amount: 100000,
      })
      .then((result) => {
        if (result.status === 200) {
          setTransactionId(result.data.verifyId);
          setCardPhone(result.data.phone);
          setIsPost(true);
        } else {
          setErrorMessage(result.data);
        }
      })
      .catch((err) => {
        if (!err.response.data.success) {
          toast.error(err.response.data[i18n.language]);
        } else {
          toast.error("Please try again.");
        }
      })
      .finally(() => {
        setPaymentLoading(false);
      });
  };

  const handlePostPayment = async (e) => {
    e.preventDefault();
    // console.log(cardDetails);
    setPaymentLoading(true);
    if (cardDetails.otp === "") {
      return toast.error(
        `Please enter one-time code that was sent to your phone number`
      );
    }

    try {
      let result = await axiosPayment.post(`/api/via/post`, {
        id: transactionId,
        code: cardDetails.otp,
        enquiryId: "TKT Mock",
        examDate: moment(examDate).format("DD/MM/YYYY"),
        ...enquiryDetails,
        phone: user.phone,
        email: user.email,
        amount: price.exam,
        candidateName: `${enquiryDetails.firstName} ${enquiryDetails.lastName}`,
        candidatePassport: enquiryDetails.passportId,
        candidateDob: moment(dob).format("DD/MM/YYYY"),
      });

      if (result.status === 200) {
        const registerData = await axios.post(
          `/api/test-register`,
          {
            transactionId: result.data.transaction.transactionId,
            userId: user._id,
            testId: testId,
            module: selectedModule,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
            },
          }
        );
        if (registerData.status === 200) {
          setShowSuccess(true);
          setIsPost(false);
          setShowPaymentForm(false);
          setTransactionDetails(result.data.transaction);
          naviagate(0);
        } else {
          toast.error(registerData.data.msg);
        }
      } else {
        setErrorMessage(result.data);
      }
    } catch (err) {
      toast.error(err.response.data[i18n.language] || t("smthWentWrong"));
    }
  };

  const handleGetPin = async (e) => {
    e.preventDefault();
    const moduleAvailable = await axios.post(`/api/module-available`, {
      userId: user._id,
      module: selectedModule,
    });
    if (!moduleAvailable.data.available) {
      return toast.error(t("moduleNA"));
    }
    setTestId(moduleAvailable.data.testId);

    const price = await axiosPayment.get(
      `/api/price?exam=TKT-Mock&module=Mock`
    );

    let percent = Math.ceil(price.data.priceAmount * 0.008);

    setPrice({
      exam: price.data.priceAmount,
      per: percent,
      total: price.data.priceAmount + percent,
    });
    if (residence === "Uzbekistan") {
      if (hasUserDetails) {
        setShowForm(true);
        setShowCard(true);
        setForPayment(true);
      }
      if (
        validate.passportState === "has-success" &&
        enquiryDetails.passportId &&
        dob
      ) {
        axiosPayment
          .post(`/api/check-details`, {
            docNumber: enquiryDetails.passportId,
            dob: moment(dob).format("YYYY-MM-DD"),
          })
          .then(async (result) => {
            if (result.status === 200) {
              const updateData = await axios.post(
                `/api/update-user`,
                {
                  userId: user._id,
                  firstName: result.data.firstName,
                  lastName: result.data.lastName,
                  pinpp: result.data.pinpp,
                  image: result.data.photo,
                  passportNo: enquiryDetails.passportId,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "*/*",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              setLoading(false);
              setEnquiryDetails({
                ...enquiryDetails,
                firstName: result.data.firstName,
                lastName: result.data.lastName,
                pinpp: result.data.pinpp,
                examDate: moment().format("DD/MM/YYYY"),
                exam: "TKT",
                module: "Mock",
                region: residence,
              });
              setShowForm(true);
              setShowCard(true);
              setForPayment(true);
            } else if (result.status === 404) {
              toast.error(t("passportOrDobWrong"));
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              toast.error(t("passportOrDobWrong"));
            }
          });
      }
    } else {
      setShowForm(true);
      setEnquiryDetails({
        ...enquiryDetails,
        firstName: "",
        lastName: "",
        pinpp: "0",
      });
      setShowCard(true);
      setForPayment(true);
    }
  };

  const handleGetDetails = async () => {
    try {
      const userDetails = await axios.get(`/api/user-details/${user._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (userDetails.data.pinpp) {
        setResidence("Uzbekistan");
        setEnquiryDetails({
          ...enquiryDetails,
          passportId: userDetails.data.passportNo,
          firstName: userDetails.data.firstName,
          lastName: userDetails.data.lastName,
          pinpp: userDetails.data.pinpp,
          examDate: moment().format("DD/MM/YYYY"),
          exam: "TKT",
          module: "Mock",
          region: "Uzbekistan",
        });
        setHasUserDetails(true);
      } else {
        setEnquiryDetails({ exam: "TKT" });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setLoading(true);
    handleGetDetails();

    setForPayment(false);
    setLoading(false);
  }, []);

  return loading ? null : (
    <div>
      <div className="col-12 ">
        {showSuccess && (
          <div className="home-text">
            <h3 className="mt-5 pt-5">{t("paidSuccess")}.</h3>
          </div>
        )}
      </div>

      <div className={"col-12"}>
        {showPaymentForm && (
          <div className="mt-2" style={{ borderRadius: "0.75rem" }}>
            <div className="text-left">
              <Form>
                <Row>
                  <Col md={"12"} lg="6">
                    <Form>
                      <h4 className="mt-4">{t("fillDetails")}:</h4>
                      <div
                        className=" mt-2"
                        style={{ borderRadius: "0.75rem" }}
                      >
                        <div className="card-body text-left">
                          <FormGroup>
                            <Label>{t("selectModule")}</Label>
                            <Select
                              required
                              className="react-select mb-3"
                              value={{
                                label: selectedModule,
                                value: selectedModule,
                              }}
                              name="module"
                              options={[
                                {
                                  label: "TKT Module 1",
                                  value: "TKT Module 1",
                                },
                                {
                                  label: "TKT Module 2",
                                  value: "TKT Module 2",
                                },
                                {
                                  label: "TKT Module 3",
                                  value: "TKT Module 3",
                                },
                              ]}
                              onChange={handleModuleChange}
                            />
                          </FormGroup>
                          {!hasUserDetails && (
                            <>
                              <FormGroup>
                                <Label>{t("residenceCountry")}</Label>
                                <Select
                                  required
                                  className="react-select mb-3"
                                  value={{
                                    label: t(residence),
                                    value: residence,
                                  }}
                                  name="residence"
                                  options={[
                                    {
                                      label: t("Uzbekistan"),
                                      value: "Uzbekistan",
                                    },
                                    {
                                      label: t("Other"),
                                      value: "Other",
                                    },
                                  ]}
                                  onChange={handleResidenceChange}
                                />
                              </FormGroup>
                              <FormGroup>
                                <Label>{t("passportNo")}</Label>
                                <Input
                                  required
                                  type="text"
                                  name="passportId"
                                  valid={
                                    residence === "Uzbekistan"
                                      ? validate.passportState === "has-success"
                                      : true
                                  }
                                  invalid={
                                    residence === "Uzbekistan"
                                      ? validate.passportState === "has-danger"
                                      : false
                                  }
                                  value={enquiryDetails?.passportId}
                                  disabled={showForm}
                                  onChange={(e) => {
                                    validatePassportId(e);
                                    handleValuesChange(e);
                                  }}
                                />{" "}
                                <FormFeedback>
                                  {t("invlaidPassportNo")}
                                </FormFeedback>
                              </FormGroup>
                              <FormGroup>
                                <Label>{t("dob")}</Label>
                                <DatePicker
                                  className={"form-control"}
                                  disabled={showForm}
                                  calendarIcon={
                                    <i className="simple-icon-calendar" />
                                  }
                                  clearIcon={<i className="iconsminds-close" />}
                                  dayPlaceholder="DD"
                                  monthPlaceholder="MM"
                                  yearPlaceholder="YYYY"
                                  format="dd/MM/y"
                                  minDate={
                                    new Date(
                                      new Date().setFullYear(
                                        new Date().getFullYear() - 100
                                      )
                                    )
                                  }
                                  value={dob ? dob : null}
                                  showLeadingZeros={true}
                                  onCalendarOpen={() => {
                                    if (!dob) {
                                      setDob(
                                        new Date(
                                          new Date().setFullYear(
                                            new Date().getFullYear() - 16
                                          )
                                        )
                                      );
                                    }
                                  }}
                                  shouldOpenCalendar={({ reason }) =>
                                    reason !== "focus"
                                  }
                                  onChange={(v) => {
                                    setDob(v);
                                  }}
                                />
                              </FormGroup>
                            </>
                          )}
                          {!showForm ? (
                            <button
                              type="submit"
                              className="btn btn-light btn-xl  mb-2"
                              onClick={(e) => handleGetPin(e)}
                            >
                              {t("proceed")}
                            </button>
                          ) : null}
                          {showForm ? (
                            <>
                              <FormGroup>
                                <Label>{t("firstName")}</Label>
                                <Input
                                  required
                                  type="text"
                                  name="firstName"
                                  disabled={residence === "Uzbekistan"}
                                  value={enquiryDetails.firstName}
                                  onChange={handleValuesChange}
                                />
                              </FormGroup>
                              <FormGroup>
                                <Label>{t("lastName")}</Label>
                                <Input
                                  required
                                  type="text"
                                  name="lastName"
                                  disabled={residence === "Uzbekistan"}
                                  value={enquiryDetails.lastName}
                                  onChange={handleValuesChange}
                                />
                              </FormGroup>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </Form>
                  </Col>

                  {showCard ? (
                    <Col md="12" lg="6">
                      <Row>
                        <Col className="mx-auto">
                          <>
                            <br />
                            <strong>{t("price")}</strong>:{" "}
                            {currencyFormatter(`${price.exam}`, "UZS")}
                            <br />
                            <strong>{t("processingFee")}</strong>:{" "}
                            {currencyFormatter(`${price.per}`, "UZS")}
                            <br />
                            <strong>{t("totalPay")}</strong>:{" "}
                            {currencyFormatter(`${price.total}`, "UZS")}
                          </>

                          <h4 className="mt-4">{t("fillDetails")}</h4>
                          <Cards
                            number={cardDetails.number}
                            expiry={cardDetails.expiry}
                            cvc={cardDetails.cvc}
                            name={cardDetails.name}
                            focused={cardDetails.focus}
                            placeholders={{ name: "" }}
                            acceptedCards={["uzcard", "humo"]}
                            preview={isPost}
                          />
                          <form>
                            <div className="form-group mb-3 mt-4">
                              <input
                                type="tel"
                                name="number"
                                className="form-control"
                                placeholder={t("cardNo")}
                                pattern="[\d| ]{16,22}"
                                required
                                value={cardDetails.number}
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                                disabled={isPost}
                              />
                            </div>
                            <div className="form-group mb-3 mt-4">
                              <input
                                type="tel"
                                name="expiry"
                                className="form-control"
                                placeholder={t("validThru")}
                                pattern="\d\d/\d\d"
                                required
                                value={cardDetails.expiry}
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                                disabled={isPost}
                              />
                            </div>

                            {isPost ? (
                              <div className="form-group mb-3 mt-4">
                                <input
                                  type="tel"
                                  name="otp"
                                  className="form-control"
                                  placeholder={t("enterCode")}
                                  pattern=""
                                  required
                                  value={cardDetails.otp}
                                  onChange={handleInputChange}
                                />

                                <p>
                                  {t("codeSent")} {cardPhone}
                                </p>

                                {/* <Tooltip id="phone" /> */}
                              </div>
                            ) : null}
                          </form>
                          {showCard && !isPost ? (
                            <button
                              type="submit"
                              className="btn btn-light btn-xl  mb-2"
                              onClick={(e) => handlePrePayment(e)}
                            >
                              {t("proceed")}
                            </button>
                          ) : null}
                          {isPost ? (
                            <button
                              type="submit"
                              className="btn btn-light btn-xl  mb-2"
                              onClick={(e) => handlePostPayment(e)}
                            >
                              {t("pay")}
                            </button>
                          ) : null}
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <p>
                          <b>{t("securePaymentTitle")}</b>
                        </p>
                        <p>
                          {t("securePayment1")} <strong>Via</strong>,{" "}
                          {t("securePayment2")}
                        </p>
                      </Row>
                    </Col>
                  ) : null}
                </Row>
              </Form>
            </div>
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                border: "1px solid #ccc",
                backgroundColor: "#f9f9f9",
              }}
            >
              <h3>{t("disclaimer")}:</h3>
              <p>{t("disclaimerText")}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Payment;
